import Home from './Home';
import Route from './route';

export default {
  RenderProp: Home,
  mainRoute: Route,
};
